import { render, staticRenderFns } from "./BaseTableSelectMoreActionsForm.vue?vue&type=template&id=5dc990c5&scoped=true"
import script from "./BaseTableSelectMoreActionsForm.vue?vue&type=script&lang=js"
export * from "./BaseTableSelectMoreActionsForm.vue?vue&type=script&lang=js"
import style0 from "./BaseTableSelectMoreActionsForm.vue?vue&type=style&index=0&id=5dc990c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc990c5",
  null
  
)

export default component.exports